import React from 'react'
import { LanguageContext, UserParticipantContext } from '../contexts'
import { RegistrationOperation } from '../Models/participant'
import { CardModal } from '../Components/Modal'
import { SpecialClassNames } from '../constants'
import classNames from 'classnames'

export interface DeregistrationModalProps {
	workshopEventId: number
	onCancel: () => void
	onConfirmDeregister: (workshopEventId: number, operation: RegistrationOperation) => void
}

export function DeregistrationModal(props: DeregistrationModalProps) {

	const { localizedText } = React.useContext(LanguageContext)
	const { deregisterParticipant } = React.useContext(UserParticipantContext)
	const [saveInProgress, setSaveInProgress] = React.useState(false)

	function handleConfirmDeregister() {
		setSaveInProgress(true)
		deregisterParticipant?.(props.workshopEventId).then(response => {
			if (response.Status == 'exception') {
				// handle error here
			}
			else {
				props.onConfirmDeregister(props.workshopEventId, 'Deregister')
			}
		})
		.finally(() => {
			setSaveInProgress(false)
		})
	}

	return (
		<CardModal title={localizedText.UnregistrationConfirmationTitle} 
				onCancel={props.onCancel} 
				primaryButton={{ text: localizedText.Unregister, color: 'danger', onClick: handleConfirmDeregister }}  
				operationInProgress={saveInProgress}
				className={classNames(SpecialClassNames.narrowModal)}
				>
			{localizedText.UnregistrationConfirmationMessage}
		</CardModal>
	)
}